var React = require('react');

function IconCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icon_checkmark","d":"M3445.047,1831.976l11.252,11.252,31.855-31.855","transform":"translate(-3440.097 -1806.422)","fill":"none","stroke":"#000000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"7"}));
}

IconCheckmark.defaultProps = {"width":"53.006","height":"40.305","viewBox":"0 0 53.006 40.305"};

module.exports = IconCheckmark;

IconCheckmark.default = IconCheckmark;
